import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import HttpRoutingService from "../../shared/services/httpRoutingService";
import { API } from "../../shared/apiRoutes";
import { config } from "../../shared/environment";
import { PaymentReportResponse } from "../../components/dashboard/paymentReport/paymentReport.module";


interface initialState { getAllPaymentReport: { loading: boolean, value: PaymentReportResponse | null, error: string, isReached: boolean, filter: string | null } }

const initialState: initialState = { getAllPaymentReport: { error: '', loading: false, value: null, isReached: false, filter: null } }

export const getAllPaymentReport = createAsyncThunk('report/paymentReport', ({ data }: { data: { offset: number, limit: number, filterData: string, locationId: number } }) => {
    let Url = HttpRoutingService.replaceUrl(API.PaymentReport, { storeId: config.storeId })
    return HttpRoutingService.getMethod<PaymentReportResponse>(Url, data)
})



export const PaymentReportSlice = createSlice({
    initialState,
    name: 'paymentReport',
    reducers: {},
    extraReducers(builder) {
        builder.addCase(getAllPaymentReport?.pending, (state) => {
            state.getAllPaymentReport.loading = true
        })
            .addCase(getAllPaymentReport.fulfilled, (state, action) => {
                state.getAllPaymentReport.loading = false
                let prev = state.getAllPaymentReport.value;
                let current = action.payload;
                let combine: PaymentReportResponse | null = null
                let offset = action.meta.arg.data.offset
                if (offset > 0) {
                    combine = {
                        message: current?.message ?? prev?.message ?? "",
                        statusCode: current?.statusCode ?? prev?.statusCode ?? "",
                        success: current?.success ?? prev?.success ?? false,
                        paymentReport: {
                            getPosOrderReport: [
                                ...(prev?.paymentReport?.getPosOrderReport || []),
                                ...(current?.paymentReport?.getPosOrderReport || []),
                            ],
                            count: current?.paymentReport?.count || 0
                        },
                    };
                }

                const totalFetched = offset > 0 ? combine?.paymentReport?.getPosOrderReport?.length : action.payload?.paymentReport?.getPosOrderReport?.length
                const totalCount = action?.payload?.paymentReport?.count

                if (current?.paymentReport?.getPosOrderReport?.length < action.meta.arg.data.limit || totalFetched! >= totalCount) {
                    state.getAllPaymentReport.isReached = true
                }
                else {
                    state.getAllPaymentReport.isReached = false
                }
                state.getAllPaymentReport.value = offset > 0 ? combine : action.payload
                state.getAllPaymentReport.filter = action.meta.arg.data.filterData
            })
        builder.addCase(getAllPaymentReport?.rejected, (state, action) => {
            state.getAllPaymentReport.loading = false
            state.getAllPaymentReport.error = action?.error?.message ? action?.error?.message : 'Error in getAllPaymentReport'
        })
    },
})


export default PaymentReportSlice?.reducer